import React from 'react';
import PropTypes from 'prop-types';
import {flexRender} from '@tanstack/react-table';

const ColumnFooter = ({footerGroups}) => {
  const footerCells = footerGroups.map((footerGroup) => {
    let pinLeftWidth = 0;
    let footerGroupCells = [];

    footerGroup.headers.forEach((header) => {
      if (header.column.getIsPinned()) {
        footerGroupCells.push(<td
          key={header.id}
          colSpan={header.colSpan ? header.colSpan : 1}
          style={{
            verticalAlign: 'text-top',
            width: header.getSize(),
            display: header.getSize() == 0 ? 'none' : '',
            left: pinLeftWidth ? pinLeftWidth : '0',
          }}
          className={'sticky-col bg-medium-gray'}
        >
          {header.isPlaceholder
            ? null
            :
            <div>
              {flexRender(
                header.column.columnDef.footer,
                header.getContext(),
              )}
            </div>
          }
        </td>);

        pinLeftWidth += header.column.getSize();
      } else {
        footerGroupCells.push(<td
          key={header.id}
          colSpan={header.colSpan ? header.colSpan : 1}
          style={{
            verticalAlign: 'text-top',
            width: header.getSize(),
            display: header.getSize() == 0 ? 'none' : '',
          }}
          className='bg-light-gray'
        >
          {header.isPlaceholder
            ? null
            :
            <div>
              {flexRender(
                header.column.columnDef.footer,
                header.getContext(),
              )}
            </div>
          }
        </td>);
      }

    });
    return <tr key={footerGroup.id}>
      {footerGroupCells}
    </tr>;
  });

  return <tfoot>
    {footerCells}
  </tfoot>;
};

ColumnFooter.propTypes = {
  footerGroups: PropTypes.array,
};

export default ColumnFooter;
